export const RESET_ORDER_CONFIRMATION_STATE = 'RESET_ORDER_CONFIRMATION_STATE'
export const RAISE_SAMPLES_ORDER_PENDING = 'RAISE_SAMPLES_ORDER_PENDING'
export const RAISE_SAMPLES_ORDER_SUCCESS = 'RAISE_SAMPLES_ORDER_SUCCESS'
export const RAISE_SAMPLES_ORDER_FAILURE = 'RAISE_SAMPLES_ORDER_FAILURE'
export const RESET_ORDER_SAMPLES_STATE = 'RESET_ORDER_SAMPLES_STATE'
